const randomArmor = require('./randomArmor.js');

/**
 * Init a new random table and display the roll result
 * @param {object} table HTML element
 */
module.exports = function (table) {
  const placeholder = table.querySelector('.__result');
  const method = table.dataset.method;
  const availableMethods = { randomArmor };

  table.classList.add('js-__enabled');
  table.onclick = () => {
    const result = availableMethods[method].run();
    if (!result.length) {
      placeholder.innerHTML = 'Nothing...';
    } else {
      placeholder.innerHTML = result.join('<br>');
    }
  };
};
